(() => {
  const key = 'cg-cart-feedback-count';
  let saved = null;
  try { saved = sessionStorage.getItem(key); } catch (_) {}
  const remember = (count) => { try { sessionStorage.setItem(key, String(count)); } catch (_) {} };
  const pop = (cart) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const badge = cart.querySelector('[id^="cart-count"]');
    if (!badge?.animate) return;
    badge.getAnimations().forEach((animation) => animation.cancel());
    badge.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(1.24)', offset: 0.45 },
      { transform: 'scale(1)' }
    ], { duration: 360, easing: 'ease-out' });
  };
  document.querySelectorAll('li.cart').forEach((cart) => {
    const readCount = () => Number(cart.querySelector('[id^="cart-count"]')?.textContent.trim() || 0);
    let previous = readCount();
    if (saved !== null && previous > Number(saved)) pop(cart);
    remember(previous);
    new MutationObserver(() => {
      const next = readCount();
      if (next > previous) pop(cart);
      previous = next;
      remember(next);
    }).observe(cart, { childList: true, characterData: true, subtree: true });
  });
})();
